// indices-by-asset-class-page.component.ts
// Vendor libraries
import { ElementRef } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../../../../../../search/static/search/ts/features/base-autocomplete/components/base-autocomplete.component";
import * as i3 from "../asset-class-indices-collapsable-table/asset-class-indices-collapsable-table.component";
const _c0 = a0 => ({ "active": a0 });
function IndicesByAssetClassPageComponent_li_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 23)(1, "a", 24);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const top_asset_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("href", "/indices/asset_class/", top_asset_r1.internal_name, "", i0.ɵɵsanitizeUrl);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0, top_asset_r1.internal_name === ctx_r1.current_top_asset.internal_name));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", top_asset_r1.display_name, " ");
} }
export class IndicesByAssetClassPageComponent {
    constructor(eltRef) {
        this.eltRef = eltRef;
        this.top_assets = [];
        this.top_assets = JSON.parse(this.eltRef.nativeElement.getAttribute('top_assets'));
        this.current_top_asset = JSON.parse(this.eltRef.nativeElement.getAttribute('current_top_asset'));
    }
    redirectToIndex(autocompleteResult) {
        window.location.href = autocompleteResult.url;
    }
}
IndicesByAssetClassPageComponent.ɵfac = function IndicesByAssetClassPageComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || IndicesByAssetClassPageComponent)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
IndicesByAssetClassPageComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: IndicesByAssetClassPageComponent, selectors: [["ycn-indices-by-asset-class-page"]], standalone: false, decls: 30, vars: 7, consts: [[1, "container"], [1, "page-header", "row"], [1, "page-title", "col-auto"], [1, "page-title-wrap"], [1, "d-flex"], [1, "page-name"], [1, "page-name-text"], [1, "page-header-navigation-inline"], ["href", "/indices", 1, "text-blue"], [1, "page-header-navigation-title"], [1, "page-header-navigation-title", "text-bold"], [1, "page-header-actions"], [1, "row", "visible-md-flex"], [1, "col-i-md-4", "d-flex", "align-items-end", "form-row"], [1, "flex-auto", "row", "no-gutters", "align-items-baseline"], [1, "col-auto"], [1, "form-label", "form-label-thin", "mr-1"], [1, "col"], [3, "submitHandler", "placeholder", "searchType", "buttonType", "showMoreResultsUrl"], [1, "page-tabs", "tabs"], ["data-tabs-content", "pageTabs", 1, "nav", "nav-tabs"], ["class", "nav-item", 4, "ngFor", "ngForOf"], [3, "parentAssetClass", "parentAssetClassDisplay"], [1, "nav-item"], [1, "nav-link", 3, "ngClass", "href"]], template: function IndicesByAssetClassPageComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "div", 4)(5, "div", 5)(6, "span", 6);
        i0.ɵɵtext(7, "Indices by Asset Class");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(8, "div", 7)(9, "a", 8)(10, "span", 9);
        i0.ɵɵtext(11, "Indices");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(12, "span");
        i0.ɵɵtext(13, "\u00A0/\u00A0");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "span", 10);
        i0.ɵɵtext(15, "Asset Class");
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(16, "div", 11)(17, "div", 12)(18, "div", 13)(19, "div", 14)(20, "div", 15)(21, "div", 16);
        i0.ɵɵtext(22, "Search All Indices");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(23, "div", 17)(24, "ycn-base-autocomplete", 18);
        i0.ɵɵlistener("submitHandler", function IndicesByAssetClassPageComponent_Template_ycn_base_autocomplete_submitHandler_24_listener($event) { return ctx.redirectToIndex($event); });
        i0.ɵɵelementEnd()()()()()()()();
        i0.ɵɵelementStart(25, "div", 19)(26, "div", 0)(27, "ul", 20);
        i0.ɵɵtemplate(28, IndicesByAssetClassPageComponent_li_28_Template, 3, 6, "li", 21);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelement(29, "ycn-asset-class-indices-collapsable-table", 22);
    } if (rf & 2) {
        i0.ɵɵadvance(24);
        i0.ɵɵproperty("placeholder", "Search")("searchType", "index")("buttonType", "icon-search")("showMoreResultsUrl", true);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngForOf", ctx.top_assets);
        i0.ɵɵadvance();
        i0.ɵɵproperty("parentAssetClass", ctx.current_top_asset.internal_name)("parentAssetClassDisplay", ctx.current_top_asset.display_name);
    } }, dependencies: [i1.NgClass, i1.NgForOf, i2.BaseAutocompleteComponent, i3.AssetClassIndicesCollapsableTableComponent], encapsulation: 2 });
